module.exports = __webpack_public_path__ + "img/d12.45e7825d.jpg";